import React from "react";

const Footer = () => {
  return (
    <footer className="bg-sky-950 text-center text-neutral-content dark:bg-neutral-600 dark:text-neutral-200 lg:text-left">
      <div className="p-6 flex flex-col md:flex-row justify-between">
        <div>
          <span>© 2026 Fialon S.</span>
          <br />
          Created by ♥ with Next, Tailwind &amp; Cosmic
        </div>
        <div className="mt-3 md:mt-0">
          <a href="/mentions-legales" className="hover:underline">
            Mentions légales
          </a>{" "}
          <br />
          <a href="/politique-confidentialite" className="hover:underline">
            Politique de confidentialité
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
